import styled from 'styled-components';

export const Wrapper = styled.main`
  display: flex;
  height: 100vh;
  width: 100%;
  overflow-y: hidden;
  position: fixed;
`;
